import { paletteBase } from '@abg/kit-base';
import { AbgSxProps } from '@abg/typings/styling';

export const accordionDetails: AbgSxProps = {
  padding: '4px 24px',
};

export const wrapperStyles: AbgSxProps = {
  '&:hover': {
    backgroundColor: paletteBase.neutralGrey200,
  },
};

export const linkStyles: AbgSxProps = {
  color: paletteBase.secondary400,
};

export const textStyles: AbgSxProps = {
  color: paletteBase.secondary400,
};

export const priceStyles: AbgSxProps = {
  color: paletteBase.secondary400,
};
